module.exports = __webpack_public_path__ + "static/media/security.13063413.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXO/images/security.svg
// module id = 1237
// module chunks = 0